export const amountCellWidth = 150;
